import client from '../httpClient';

// webRes002
const webResCreateCustomerApi = (params, isShowLoading = true) => {
  return client.post('/responses/create-customer/', params, { isShowLoading });
};

export default webResCreateCustomerApi;
